/// <amd-module name="VSSUI/Components/Tabs/TabContent" />
import * as React from "react";

import { ObservableArray } from "VSS/Core/Observable";

import { ITabProviderContext } from "VSSUI/Components/Tabs/Tabs.Props";

import { TabProviderContext, TabProvider } from "./TabProviderContext";

/**
 * Hooks into tab provider context to render the tab's provided content, as well
 * as optionally the a filter bar if it is to be rendered outside of the TabBar.
 */
export class TabContent extends React.Component<{}> {
    public render() {
        return (
            <TabProviderContext.Consumer>
                {(tabProviderContext: ITabProviderContext) => {
                    let content: JSX.Element;
                    if (tabProviderContext.renderContent) {
                        const filterBar = tabProviderContext.renderFilterBar && tabProviderContext.renderFilterBar(false);
                        content = (
                            <>
                                {filterBar}
                                {tabProviderContext.renderContent()}
                            </>
                        );
                    } else {
                        content = <>{this.props.children}</>;
                    }
                    return (
                        <TabProvider providers={new ObservableArray([])} selectedTabId={tabProviderContext.selectedId || ""}>
                            {content}
                        </TabProvider>
                    );
                }}
            </TabProviderContext.Consumer>
        );
    }
}
